"use strict";

var _classCallCheck = require("D:\\workspace\\forkfolio-ui\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IEvents = void 0;

var IEvents = function IEvents() {
  _classCallCheck(this, IEvents);
};

exports.IEvents = IEvents;